const CONSTANTS = {
  GET_MAIN_PAGE_BANNERS: "GET_MAIN_PAGE_BANNERS",
  SET_MAIN_PAGE_BANNERS: "SET_MAIN_PAGE_BANNERS",

  GET_MAIN_PAGE_NEWS_AND_BLOGS: "GET_MAIN_PAGE_NEWS_AND_BLOGS",
  SET_MAIN_PAGE_NEWS_AND_BLOGS: "SET_MAIN_PAGE_NEWS_AND_BLOGS",

  GET_NEWS_AND_BLOGS_DETAILD_DATA: "GET_NEWS_AND_BLOGS_DETAILD_DATA",
  SET_NEWS_AND_BLOGS_DETAILD_DATA: "SET_NEWS_AND_BLOGS_DETAILD_DATA",

  SET_NEWS_AND_BLOGS_GLOBAL_ID: "SET_NEWS_AND_BLOGS_GLOBAL_ID",

  SET_GLOBAL_PAGE_LOADER: "SET_GLOBAL_PAGE_LOADER",
};

export default CONSTANTS;
